import { SxProps } from '@mui/material';
import theme from '@theme/index';

const { palette, typography, spacing } = theme;

const videControls = {
  position: 'absolute',
  bottom: {
    xs: '-4rem',
    md: '1rem'
  },
  display: 'flex',
  justifyContent: 'center'
};

export const tabBtnCommon = {
  display: 'flex',
  alignItems: 'center',
  padding: {
    xs: 0,
    md: spacing(0.5)
  },
  height: '2rem'
};

const styles: Record<string, SxProps> = {
  mediaDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginBottom: {
      sm: spacing(1),
      md: 0
    }
  },

  mediaDetailsContainerNewHomes: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem'
  },

  mapStylesCustom: {
    '.gmnoprint': {
      top: {
        xs: '8.6rem !important',
        md: '12.6rem !important'
      }
    }
  },

  mediaDetailVideo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',

    iframe: {
      width: { xs: '100vw', sm: '100%' },
      objectFit: 'fill',
      height: { xs: '56.25vw', sm: '37.5rem' },
      border: 0
    },

    '& > div:nth-of-type(2)': {
      background: palette.grey['50']
    }
  },

  contentContainer: {
    display: 'flex',
    justifyContent: 'center'
  },

  videoMediaDetailsContainer: {
    position: 'relative',
    width: '100%',
    maxHeight: {
      md: '35rem',
      xs: '15rem'
    },
    height: '35rem',
    textAlign: 'center',
    marginBottom: {
      xs: '3rem',
      md: 0
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    width: '100%',
    background: palette.grey['50']
  },
  saveContainer: {
    position: 'relative',
    display: {
      xs: 'block',
      md: 'none'
    }
  },
  iconBtn: {
    position: 'absolute',
    top: spacing(0.5),
    left: spacing(0.5),
    zIndex: 2,
    background: palette.transparentBlackishGrey.main,
    borderRadius: '0.25rem',
    padding: spacing(0.5),

    '& > svg': {
      color: palette.grey['50'],
      width: '1.5rem',
      opacity: 0.6,

      '&.saved': {
        color: palette.torchRed[200]
      }
    }
  },
  controls: {
    backgroundColor: palette.grey[50],
    border: {
      xs: 'none',
      md: `0.063rem solid ${palette.primary[400]}`
    },
    borderRadius: '0.5rem',
    paddingX: spacing(0.5),
    paddingY: {
      md: spacing(0.5)
    },
    display: 'flex',
    flexWrap: 'wrap',
    gap: spacing(0.25),
    width: 'fit-content'
  },
  selectedControlItem: {
    ...tabBtnCommon,
    width: 'fit-content',
    background: palette.primary.light,
    borderRadius: '0.25rem',
    textAlign: 'center',
    '&:hover': {
      color: palette.grey[50],
      backgroundColor: palette.primary.light
    }
  },
  controlItem: {
    ...tabBtnCommon,
    width: 'fit-content',
    textAlign: 'center',
    background: {
      xs: palette.grey[200],
      md: palette.grey[50]
    }
  },
  selectedControlItemText: {
    color: palette.grey[50],
    padding: '0rem',
    cursor: 'pointer',
    fontSize: {
      xs: typography.body2.fontSize,
      lg: typography.body1.fontSize
    }
  },
  controlItemText: {
    color: palette.grey[400],
    padding: '0rem',
    cursor: 'pointer',
    fontSize: {
      xs: typography.body2.fontSize,
      lg: typography.body1.fontSize
    }
  },
  controlsWrapper: {
    position: 'absolute',
    bottom: {
      xs: '1rem',
      md: '1.5rem'
    },
    display: 'flex',
    justifyContent: 'center'
  },
  videoControlsWrapper: {
    ...videControls
  },
  messageDisclaimer: {
    background: palette.primary[400],
    padding: '0.3125rem',
    display: 'flex'
  },
  icon: {
    color: theme.palette.primary.main,
    width: { xs: '2.922rem', md: '3.531rem' },
    height: { xs: '2.922rem', md: '3.531rem' },
    '& path': {
      fill: theme.palette.primary.main
    }
  },
  iconBg: {
    backgroundColor: theme.palette.grey[50],
    display: 'flex',
    width: { xs: '6rem', md: '7.25rem' },
    height: { xs: '6rem', md: '7.25rem' }
  },
  tourControlsWrapper: {
    ...videControls,
    bottom: {
      xs: '-4rem',
      lg: '1rem'
    }
  }
};

export default styles;
